import { render, staticRenderFns } from "./ImportQuestionList.vue?vue&type=template&id=c3673cb8"
import script from "./ImportQuestionList.vue?vue&type=script&lang=js"
export * from "./ImportQuestionList.vue?vue&type=script&lang=js"
import style0 from "./ImportQuestionList.vue?vue&type=style&index=0&id=c3673cb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports